import { useEffect } from "react";
import * as Sentry from "@sentry/nextjs";
import { UserContextState } from "@contexts/UserContext";

const useInitSentry = (userContext?: UserContextState): void => {
  useEffect(() => {
    if (
      userContext?.user &&
      process.env.NEXT_PUBLIC_VERCEL_ENV === "production"
    ) {
      Sentry.setUser({
        email: userContext.user.email || "",
        id: userContext.user.id.toString(),
        name: userContext.user.name,
      });
    }
  }, [userContext]);
};

export default useInitSentry;
